<template>

  <div class="navbar-top__search-form-container" id="product-search">

    <form
            method="GET"
            action="/busca"
            @submit="validateForm"
            class="navbar-top__search-form"
    >
      <input
              type="text"
              name="item"
              v-model="strSearch"
              @input="searchProducts"
              placeholder="Faça sua busca"
              autocomplete="off"
              class="navbar-top__search-input"
      >
      <button type="submit" class="navbar-top__search-submit">
        <i aria-hidden="true" class="fa fa-search"></i>
      </button>
    </form>

    <ul
            v-show="showSearchResults"
            class="search__autocomplete-list"
    >

      <li
              v-for="(product, index) in searchResults"
              :key="product.id"
              v-if="index <= 12"
              class="search__autocomplete-item"
      >
        <a
                href="#"
                @click.prevent="goToProductPage(product)"
                class="search__autocomplete-link"
        >
          {{product.name}}
        </a>
      </li>

    </ul>

  </div>

</template>

<script>

  import api from '../support/api';
  import debounce from 'lodash/debounce';

  export default {

    name: "SearchForm.vue",

    created(){
      bus.$on('productSearch/fetch', (strSearch) => {
        this.strSearch = strSearch;
        this.fetchProducts();
      });
    },

    mounted() {

      let vm = this;

      //fecha a listagem de resultados da busca quando se clica fora da div...
      window.addEventListener('click', function (e) {

        if (!document.getElementById('product-search')) {
          return;
        }

        if (!document.getElementById('product-search').contains(e.target)) {
          vm.products = [];
        }

      })

    },

    data() {

      return {
        strSearch: '',
        products: [],
        // showSearchResults: false,
      };

    },

    methods: {

      searchProducts: debounce((e) => {
        let strSearch = e.target.value;

        bus.$emit('productSearch/fetch', strSearch);
      }, 600),

      fetchProducts(){
        if(this.strSearch.length > 3) {
          api.fetchProducts(this);
        } else {
          this.products = [];
        }
      },

      validateForm(e){

        if(!this.strSearch.length){
          e.preventDefault();
        }

      },

      // searchProducts(){
      //
      //   if(this.products.length === 0 && this.strSearch.length > 3) {
      //     api.fetchProducts(this);
      //   } else {
      //     this.showSearchResults = true;
      //   }
      //
      // },

      goToProductPage(product){
        window.location = '/produto/' + product.slug;
      }

    },

    computed: {

      searchResults: function () {

        let vm = this;

        return this.products.filter(function (product) {
          return product.name.toLowerCase().indexOf(vm.strSearch.toLowerCase()) >= 0;
        })

      },

      showSearchResults(){
        return this.products.length;
      }

    }

  }
</script>
